import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 180px;
`;

interface IInput {
  searched: boolean;
}

export const Input = styled.input<IInput>`
  border: none;
  background: none;
  outline: 0;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  width: 100%;
  margin-left: 8px;
  padding-right: ${({ searched }) => (searched ? '20px' : '50px')};
`;

export const SearchIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const SearchButton = styled.div`
  position: absolute;
  right: 0;
  font-size: 12px;
  color: #1371fe;
  font-weight: 500;
  cursor: pointer;
`;
